












import { defineComponent } from '@vue/composition-api'
export default defineComponent({
  props: {
    productIcon: { type: String, default: 'NAME', required: true },
    title: { type: String, default: 'TITLE', required: true },
    content: { type: String, default: 'CONTENT', required: true },
    url: { ype: String, default: '/', required: true }
  },
  setup(props) {
    return {
      jumpProduct() {
        open(props.url, '_blank')
      }
    }
  }
})
